import { NavLink } from 'react-router-dom'
import { useLayoutDispatch } from '@context/layout/context/layout.context'
import { IMenuItems } from '@components/nav/SideBar/Sidebar'

export interface ISideBarMenuBlockProps {
  key: string
  heading: string
  menuItems: IMenuItems[]
}

function SideBarMenuBlock(props: ISideBarMenuBlockProps) {
  const { toggleSideBar } = useLayoutDispatch()
  return (
    <div>
      <hr className="sidebar-divider" />
      <div className="sidebar-heading">{props.heading}</div>
      {props.menuItems.map((menuItem) => (
        <li
          onClick={toggleSideBar}
          key={menuItem.tab ? `${menuItem.href}/${menuItem.tab}` : menuItem.href}
          className="nav-item">
          <NavLink
            className={({ isActive }) => 'nav-link pb-1' + (isActive ? ' active' : '')}
            to={menuItem.href}
          >
            {menuItem.icon}
            <span style={{ marginLeft: '1em' }}>{menuItem.title}</span>
          </NavLink>
        </li>
      ))}
    </div>
  )
}

export default SideBarMenuBlock
